import { JsonRpcSigner } from '@ethersproject/providers'
import { ChainId } from 'symbiosis-js-sdk'

export enum WalletStatus {
	CONNECTING,
	CONNECTED,
	DISCONNECTED,
}

export type WalletState = {
	signer: JsonRpcSigner
	status: WalletStatus
	account: Address
	chainId: ChainId
}

export type WalletMethods = {
	setChain: (chainId: ChainId) => Promise<void>
	isCurrentChain: (chainId: ChainId) => boolean
}

export type WalletHook = WalletState & WalletMethods
